// exclude-from-index
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import Styled from './Input.styles';
import { muiGlobalTheme } from './Input.theme';
import { colors } from '../../../../../css';

export default class Input extends Component {
  static propTypes = {
    outlined: PropTypes.bool
  };

  static defaultProps = {
    outlined: false
  };

  constructor(props) {
    super(props);
    muiGlobalTheme.palette.text.primary = '#000';
    muiGlobalTheme.palette.text.secondary = colors.colorGrey03;
    muiGlobalTheme.overrides.MuiIconButton = { root: { marginBottom: 10 } };

    /**
     * MUI v3 broke Typography and forces you to use a migration path even if you aren't modifying the Typography API
     * This gets rid of a console log error
     * More info: https://material-ui.com/style/typography/#migration-to-typography-v2
     * */
    muiGlobalTheme.typography.useNextVariants = true;
    this.theme = createTheme(muiGlobalTheme);
  }

  renderStandardInput = () => {
    const { outlined, ...props } = this.props;
    return (
      <MuiThemeProvider theme={this.theme}>
        <Styled.MuiInput type="number" {...props} />
      </MuiThemeProvider>
    );
  };

  renderOutlinedInput = () => (
    <Styled.Container>
      <Styled.Input type="number" {...this.props} />
    </Styled.Container>
  );

  render() {
    const { outlined } = this.props;
    return outlined ? this.renderOutlinedInput() : this.renderStandardInput();
  }
}
